module.exports = __webpack_public_path__ + "img/user.da042e3d.png";